import { Wrench } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const WrenchIcon = createLucideIcon(Wrench);
